<div style="height: 100%; max-height: 100%; overflow-y: auto;" data-cy="tree-container">
  <app-tdo-tree-item #item (itemDropped)="onItemDropped($event, item.model)" (itemSelected)="onItemSelected($event)" [template]="template" [model]="model" *ngFor="let model of dataSource; index as i" data-cy="tree-item">

  </app-tdo-tree-item>
</div>
